'use strict';

import { CLOSED, RESTORED, MAXIMIZED, MINIMIZED } from '@/constants/windowConstants';
import EcsInteractionWindow from '@/components/ecs-window/EcsInteractionWindow';

const createInteractionWindow = ({ commit }, interactionId) => {
  const interactionWindow = new EcsInteractionWindow(interactionId);
  commit('createInteractionWindow', interactionWindow);
  commit('updateFocusedWindow', interactionId);
};

const editInteractionWindow = ({ commit }, interactionWindow) => {
  if (interactionWindow.interactionId) {
    commit('updateInteractionWindow', interactionWindow);
  }
};

const maximizeInteractionWindow = ({ dispatch }, interactionId) => {
  dispatch('updateWindowState', { interactionId, state: MAXIMIZED });
};

const minimizeInteractionWindow = ({ commit, dispatch }, interactionId) => {
  dispatch('updateWindowState', { interactionId, state: MINIMIZED });
  commit('removeFocusedWindow', interactionId);
};

const restoreInteractionWindow = ({ dispatch, getters }, interactionId) => {
  const interactionWindow = getters.getInteractionWindow(interactionId);
  if (!interactionWindow) {
    dispatch('createInteractionWindow', interactionId);
  }

  const openInteractions = getters.getOpenWindowsInteractionIds;
  if (openInteractions.length === 0) {
    dispatch('updateWindowState', {
      interactionId,
      state: interactionWindow.isMinimized ? interactionWindow.previousState : RESTORED
    });
  } else {
    dispatch('updateWindowState', {
      interactionId,
      state: RESTORED
    });
    openInteractions.forEach(id => {
      dispatch('updateWindowState', {
        id,
        state: RESTORED
      });
    });
  }
};

const closeInteractionWindow = ({ commit, dispatch }, interactionId) => {
  dispatch('updateWindowState', { interactionId, state: CLOSED });
  commit('removeFocusedWindow', interactionId);
};

const updateWindowState = ({ commit, getters }, { interactionId, state }) => {
  const interactionWindow = getters.getInteractionWindow(interactionId);
  if (!interactionWindow) {
    return;
  }

  interactionWindow.currentState = state;
  commit('updateInteractionWindow', interactionWindow);
};

const setFocusedInteractionId = ({ commit }, interactionId) => {
  commit('updateFocusedWindow', interactionId);
};

const setFocusedElementId = ({ commit }, elementId) => {
  commit('updateFocusedElement', elementId);
};

const removeFocusedInteractionId = ({ commit }, interactionId) => {
  commit('removeFocusedWindow', interactionId);
};

const clearFocusedInteraction = ({ commit }, interactionId) => {
  commit('clearFocusedWindows', interactionId);
};

export default {
  createInteractionWindow,
  clearFocusedInteraction,
  closeInteractionWindow,
  editInteractionWindow,
  maximizeInteractionWindow,
  minimizeInteractionWindow,
  removeFocusedInteractionId,
  restoreInteractionWindow,
  setFocusedInteractionId,
  updateWindowState,
  setFocusedElementId
};
